<template>
  <v-dialog v-model="open" max-width="500px" persistent>
    <v-card flat>
      <v-form ref="form" v-model="valid">
        <v-card-title>
          <v-icon>mdi-share</v-icon>
          {{ t("transferencia") }}
        </v-card-title>
        <v-card-text>
          <v-radio-group v-model="tipoForm" :mandatory="false" required>
            <v-radio :label="t(`fila`)" value="fila"></v-radio>
            <v-radio :label="t(`agente`)" value="agente"></v-radio>
          </v-radio-group>
          <v-select
            prepend-icon="mdi-account-group"
            v-model="queue"
            :label="t(`fila`)"
            :items="itemsFila"
            required
            :rules="[(v) => !!v || 'Campo obrigatório']"
          ></v-select>
          <v-select
            v-if="tipoForm === 'agente'"
            prepend-icon="mdi-account"
            v-model="agente"
            :label="t(`agente`)"
            :items="itemsAgente"
            required
            :rules="[(v) => !!v || 'Campo obrigatório']"
          ></v-select>

          <!-- <b-form-group
            id="input-group-1"
            :label="t(`fila`)"
            label-for="input-1"
          >
            <b-form-select
              id="input-1"
              v-model="queue"
              required
              style="max-height: 50px !important"
            >
              <option
                v-for="(item, index) in filterFilas()"
                :key="index"
                :value="item.name"
              >
                {{ item.name }}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group
            id="input-group-2"
            :label="t(`agente`)"
            label-for="input-2"
            v-if="tipoForm === 'agente'"
          >
            <b-form-select id="input-2" v-model="agente" required v-if="queue">
              <option
                v-for="(item, index) in filterAgentes(queue)"
                :key="index"
                :value="item"
              >
                {{ item.nome }}
              </option>
            </b-form-select>
          </b-form-group> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="transferir()">
            {{ t("transferir") }}</v-btn
          >
          <v-btn color="red" text @click="cancelar()">{{
            t("cancelar")
          }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>
   
<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";
export default {
  name: "Transferencia",
  props: {
    open: { type: Boolean, default: false },
    atendimento: { type: Object, default: null },
  },
  data() {
    return {
      ip: process.env.VUE_APP_API_URL,
      tipoForm: null,
      queue: null,
      agente: null,
      valid: false,
    };
  },
  created() {
    // if(this.token) this.$router.push("/main");
  },
  computed: {
    ...mapState("xc", {
      cliente: (state) => state.cliente,
      agentes: (state) => state.agentes,
      filas: (state) => state.filas,
    }),
    itemsAgente() {
      return this.filterAgentes(this.queue).map((a) => a.nome);
    },
    itemsFila() {
      return this.filterFilas().map((a) => a.name);
    },
  },

  methods: {
    ...mapActions("xc", [
      "getDefault",
      "updateCliente",
      "transfereAtendimento",
      "setTransferenciaModal",
    ]),
    cancelar() {
      this.$emit("update:open", false);
    },
    filterAgentes(fila) {
      if (this.agentes && this.agentes !== null) {
        let agentes = this.agentes.filter((a) => {
          let filaAux = a.filas.map((queue) => queue.fila);

          if (filaAux.indexOf(fila) !== -1) {
            return a;
          }
        });

        return agentes.sort(function (a, b) {
          return a.nome.toLowerCase() > b.nome.toLowerCase()
            ? 1
            : b.nome.toLowerCase() > a.nome.toLowerCase()
            ? -1
            : 0;
        });
      }
    },
    filterFilas() {
      if (!this.filas) return [];
      if (!this.atendimento) return [];
      let retorno = this.filas.filter(
        (f) => f.queue_type === this.atendimento.queueTypeID
      );
      return retorno.sort(function (a, b) {
        return a.name.toLowerCase() > b.name.toLowerCase()
          ? 1
          : b.name.toLowerCase() > a.name.toLowerCase()
          ? -1
          : 0;
      });
    },
    transferir() {
      //this.setTransferenciaModal(false);
      if (!this.$refs.form.validate()) return;

      this.$emit("update:open", false);
      // this.atendimento.queue = this.queue.name;
      this.transfereAtendimento({
        tipo: this.tipoForm,
        fila: this.filterFilas().find((f) => f.name == this.queue).name,
        agente: this.filterAgentes(this.queue).find(
          (a) => a.nome === this.agente
        ),
        atendimento: this.atendimento,
      });
    },
  },
};
</script>
<style>
</style>